// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-layout {
  min-height: 100vh;
  background: #f5f5f5;
}

.search-content {
  padding: 24px 0;
  min-height: calc(100vh - 72px);
}

/* 移动端和PAD端使用固定高度布局 */
@media (max-width: 768px) {
  .search-layout {
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .search-content {
    flex: 1 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 16px 0;
  }
}

.search-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.search-header {
  margin-bottom: 32px;
  text-align: center;
}

.search-title-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
}

.page-title {
  color: #2D3436;
  font-weight: 700;
  margin: 0 !important;
  display: flex;
  align-items: center;
  gap: 12px;
}

.home-button {
  color: var(--color-primary, #6C5CE7);
  font-weight: 500;
  transition: all 0.3s ease;
}

.home-button:hover {
  color: var(--color-primary-hover, #5B4CDB);
  background-color: var(--color-primary-light, rgba(108, 92, 231, 0.1));
}

.page-title .anticon {
  color: #6C5CE7;
  font-size: 28px;
}

.search-input-section {
  max-width: 600px;
  margin: 0 auto;
}

.main-search-input {
  border-radius: 50px !important;
  border: 2px solid #e8e8e8 !important;
  padding: 12px 24px !important;
  font-size: 16px !important;
  height: 56px !important;
  transition: all 0.3s ease;
}

.main-search-input:focus {
  border-color: #6C5CE7 !important;
  box-shadow: 0 0 0 4px rgba(108, 92, 231, 0.1) !important;
}

.main-search-input:hover {
  border-color: #6C5CE7 !important;
}

.search-icon {
  color: #6C5CE7;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.search-icon:hover {
  color: #5A4FCF;
  transform: scale(1.1);
}

.search-results {
  margin-top: 32px;
}

.loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 60px 0;
  gap: 16px;
}

.loading-text {
  color: #636e72;
  font-size: 16px;
}

.results-header {
  margin-bottom: 24px;
}

.results-title {
  color: #2D3436;
  font-weight: 600;
  margin-bottom: 0 !important;
}

.empty-results {
  padding: 60px 0;
}

.empty-results .ant-empty-description {
  color: #636e72;
  font-size: 16px;
  line-height: 1.6;
}

.search-placeholder {
  text-align: center;
  padding: 80px 0;
}

.placeholder-icon {
  font-size: 64px;
  color: #ddd;
  margin-bottom: 24px;
  display: block;
}

.placeholder-title {
  color: #636e72;
  font-weight: 600;
  margin-bottom: 12px !important;
}

.placeholder-text {
  color: #999;
  font-size: 16px;
  margin: 0;
}

/* Mobile and Tablet Responsive */
@media (max-width: 768px) {
  .search-container {
    padding: 0 16px;
  }

  .search-header {
    margin-bottom: 24px;
  }

  .page-title {
    font-size: 24px;
    margin-bottom: 20px !important;
  }

  .page-title .anticon {
    font-size: 24px;
  }

  .main-search-input {
    font-size: 14px !important;
    height: 48px !important;
    padding: 10px 20px !important;
  }

  .search-icon {
    font-size: 16px;
  }

  .search-results {
    margin-top: 24px;
  }

  .loading-container {
    padding: 40px 0;
  }

  .loading-text {
    font-size: 14px;
  }

  .results-title {
    font-size: 16px;
  }

  .empty-results {
    padding: 40px 0;
  }

  .empty-results .ant-empty-description {
    font-size: 14px;
  }

  .search-placeholder {
    padding: 60px 0;
  }

  .placeholder-icon {
    font-size: 48px;
    margin-bottom: 20px;
  }

  .placeholder-title {
    font-size: 18px;
  }

  .placeholder-text {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .search-content {
    padding: 12px 0;
  }

  .search-container {
    padding: 0 12px;
  }

  .search-header {
    margin-bottom: 20px;
  }

  .page-title {
    font-size: 20px;
    margin-bottom: 16px !important;
  }

  .page-title .anticon {
    font-size: 20px;
  }

  .main-search-input {
    font-size: 14px !important;
    height: 44px !important;
    padding: 8px 16px !important;
  }

  .search-results {
    margin-top: 20px;
  }

  .placeholder-icon {
    font-size: 40px;
    margin-bottom: 16px;
  }

  .placeholder-title {
    font-size: 16px;
  }

  .placeholder-text {
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Search/Search.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA,qBAAqB;AACrB;EACE;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,qEAAqE;AACvE;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".search-layout {\n  min-height: 100vh;\n  background: #f5f5f5;\n}\n\n.search-content {\n  padding: 24px 0;\n  min-height: calc(100vh - 72px);\n}\n\n/* 移动端和PAD端使用固定高度布局 */\n@media (max-width: 768px) {\n  .search-layout {\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n  }\n\n  .search-content {\n    flex: 1;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 16px 0;\n  }\n}\n\n.search-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.search-header {\n  margin-bottom: 32px;\n  text-align: center;\n}\n\n.search-title-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.page-title {\n  color: #2D3436;\n  font-weight: 700;\n  margin: 0 !important;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.home-button {\n  color: var(--color-primary, #6C5CE7);\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.home-button:hover {\n  color: var(--color-primary-hover, #5B4CDB);\n  background-color: var(--color-primary-light, rgba(108, 92, 231, 0.1));\n}\n\n.page-title .anticon {\n  color: #6C5CE7;\n  font-size: 28px;\n}\n\n.search-input-section {\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.main-search-input {\n  border-radius: 50px !important;\n  border: 2px solid #e8e8e8 !important;\n  padding: 12px 24px !important;\n  font-size: 16px !important;\n  height: 56px !important;\n  transition: all 0.3s ease;\n}\n\n.main-search-input:focus {\n  border-color: #6C5CE7 !important;\n  box-shadow: 0 0 0 4px rgba(108, 92, 231, 0.1) !important;\n}\n\n.main-search-input:hover {\n  border-color: #6C5CE7 !important;\n}\n\n.search-icon {\n  color: #6C5CE7;\n  font-size: 18px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.search-icon:hover {\n  color: #5A4FCF;\n  transform: scale(1.1);\n}\n\n.search-results {\n  margin-top: 32px;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 60px 0;\n  gap: 16px;\n}\n\n.loading-text {\n  color: #636e72;\n  font-size: 16px;\n}\n\n.results-header {\n  margin-bottom: 24px;\n}\n\n.results-title {\n  color: #2D3436;\n  font-weight: 600;\n  margin-bottom: 0 !important;\n}\n\n.empty-results {\n  padding: 60px 0;\n}\n\n.empty-results .ant-empty-description {\n  color: #636e72;\n  font-size: 16px;\n  line-height: 1.6;\n}\n\n.search-placeholder {\n  text-align: center;\n  padding: 80px 0;\n}\n\n.placeholder-icon {\n  font-size: 64px;\n  color: #ddd;\n  margin-bottom: 24px;\n  display: block;\n}\n\n.placeholder-title {\n  color: #636e72;\n  font-weight: 600;\n  margin-bottom: 12px !important;\n}\n\n.placeholder-text {\n  color: #999;\n  font-size: 16px;\n  margin: 0;\n}\n\n/* Mobile and Tablet Responsive */\n@media (max-width: 768px) {\n  .search-container {\n    padding: 0 16px;\n  }\n\n  .search-header {\n    margin-bottom: 24px;\n  }\n\n  .page-title {\n    font-size: 24px;\n    margin-bottom: 20px !important;\n  }\n\n  .page-title .anticon {\n    font-size: 24px;\n  }\n\n  .main-search-input {\n    font-size: 14px !important;\n    height: 48px !important;\n    padding: 10px 20px !important;\n  }\n\n  .search-icon {\n    font-size: 16px;\n  }\n\n  .search-results {\n    margin-top: 24px;\n  }\n\n  .loading-container {\n    padding: 40px 0;\n  }\n\n  .loading-text {\n    font-size: 14px;\n  }\n\n  .results-title {\n    font-size: 16px;\n  }\n\n  .empty-results {\n    padding: 40px 0;\n  }\n\n  .empty-results .ant-empty-description {\n    font-size: 14px;\n  }\n\n  .search-placeholder {\n    padding: 60px 0;\n  }\n\n  .placeholder-icon {\n    font-size: 48px;\n    margin-bottom: 20px;\n  }\n\n  .placeholder-title {\n    font-size: 18px;\n  }\n\n  .placeholder-text {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .search-content {\n    padding: 12px 0;\n  }\n\n  .search-container {\n    padding: 0 12px;\n  }\n\n  .search-header {\n    margin-bottom: 20px;\n  }\n\n  .page-title {\n    font-size: 20px;\n    margin-bottom: 16px !important;\n  }\n\n  .page-title .anticon {\n    font-size: 20px;\n  }\n\n  .main-search-input {\n    font-size: 14px !important;\n    height: 44px !important;\n    padding: 8px 16px !important;\n  }\n\n  .search-results {\n    margin-top: 20px;\n  }\n\n  .placeholder-icon {\n    font-size: 40px;\n    margin-bottom: 16px;\n  }\n\n  .placeholder-title {\n    font-size: 16px;\n  }\n\n  .placeholder-text {\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
